// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wallet_cards__sD\\+63 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .Wallet_cards__sD\\+63 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 31.25em) {
  .Wallet_cards__sD\\+63 {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Wallet_cards__ngn__2n9V9 {
  height: 10rem;
  border-radius: 5px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  background-color: var(--color-primary-10);
}
.Wallet_cards__usd__Li8Kx {
  height: 10rem;
  border-radius: 5px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  background-color: var(--color-primary-11);
}
.Wallet_cards__eur__1zOKA {
  height: 10rem;
  border-radius: 5px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  background-color: var(--color-primary-9);
}
.Wallet_cards__gbp__2pthO {
  height: 10rem;
  border-radius: 5px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  background-color: var(--color-primary-7);
}

.Wallet_searchFilter__RF2-L {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 5.6rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Wallet_searchFilter__RF2-L {
    flex-direction: column-reverse;
    justify-content: center;
    gap: 4rem;
  }
}

.Wallet_tableTitle__2ven2 {
  display: grid;
  width: fit-content;
  margin-top: 3rem;
  gap: 3rem;
  color: #9898AB;
  border-bottom: 1px solid #D1D1D1;
}

.Wallet_main_nav__ZZYL6 {
  display: flex;
  margin: 5rem 0;
  border-bottom: solid 1px var(--color-dark);
  gap: 2rem;
  width: fit-content;
}
.Wallet_main_nav_item__P8s\\+v {
  cursor: pointer;
  padding: 1rem 0;
  font-size: var(--default-font-small);
}
.Wallet_main_nav_item_active__ig1V0 {
  cursor: pointer;
  padding: 1rem 0;
  font-weight: 700;
  border-bottom: solid 2px var(--color-dark);
}
.Wallet_main_nav_item__P8s\\+v:hover, .Wallet_main_nav_item__P8s\\+v:focus, .Wallet_main_nav_item__P8s\\+v:focus-visible, .Wallet_main_nav_item__P8s\\+v:focus-within {
  font-weight: 700;
}

.Wallet_tr2__w7V5Q {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  padding: 1rem 0;
}
.Wallet_tr2__w7V5Q > td,
.Wallet_tr2__w7V5Q th {
  display: flex;
  width: fit-content;
  flex-wrap: nowrap;
}

.Wallet_type__fFNTN {
  content: "";
  background-color: var(--color-green);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 1.5rem;
  margin-right: 1rem;
  display: flex;
}
.Wallet_type__exp__07Z7q {
  background-color: var(--color-error);
}
.Wallet_type__inc__IT6Vc {
  background-color: var(--color-green);
}

.Wallet_filterClass__3lhwg {
  display: flex;
  justify-content: space-between;
  margin-top: 5rem;
}
@media only screen and (max-width: 43.75em) {
  .Wallet_filterClass__3lhwg {
    flex-direction: column-reverse;
    gap: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/Wallet.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AADD;AAGC;EALD;IAME,qCAAA;EAAA;AACF;AAEC;EATD;IAUE,qCAAA;EACA;AACF;AACC;EAEC,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AAAF;AAGC;EAEC,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AAFF;AAKC;EAEC,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;AAJF;AAOC;EAEC,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wCAAA;AANF;;AAUA;EACC,aAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAPD;AASC;EAPD;IAQE,8BAAA;IACA,uBAAA;IACA,SAAA;EANA;AACF;;AASA;EACC,aAAA;EAEA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gCAAA;AAPD;;AAYC;EACC,aAAA;EACA,cAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;AATF;AAWE;EACC,eAAA;EACA,eAAA;EACA,oCAAA;AATH;AAWG;EACC,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AATJ;AAYG;EAIC,gBAAA;AAbJ;;AAmBA;EACC,aAAA;EACA,qCAAA;EACA,eAAA;AAhBD;AAkBC;;EAEC,aAAA;EACA,kBAAA;EACA,iBAAA;AAhBF;;AAoBA;EACC,WAAA;EACA,oCAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EAEA,kBAAA;EACA,aAAA;AAlBD;AAoBC;EACC,oCAAA;AAlBF;AAqBC;EACC,oCAAA;AAnBF;;AAuBA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AApBD;AAsBC;EALD;IAMC,8BAAA;IACA,SAAA;EAnBC;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.cards {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, 1fr);\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n\n\t&__ngn {\n\t\t// width: 30rem;\n\t\theight: 10rem;\n\t\tborder-radius: 5px;\n\t\tfont-family: 'Montserrat';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tbackground-color: var(--color-primary-10);\n\t}\n\n\t&__usd {\n\t\t// width: 30rem;\n\t\theight: 10rem;\n\t\tborder-radius: 5px;\n\t\tfont-family: 'Montserrat';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tbackground-color: var(--color-primary-11);\n\t}\n\n\t&__eur {\n\t\t// width: 30rem;\n\t\theight: 10rem;\n\t\tborder-radius: 5px;\n\t\tfont-family: 'Montserrat';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tbackground-color: var(--color-primary-9);\n\t}\n\n\t&__gbp {\n\t\t// width: 30rem;\n\t\theight: 10rem;\n\t\tborder-radius: 5px;\n\t\tfont-family: 'Montserrat';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\tbackground-color: var(--color-primary-7);\n\t}\n}\n\n.searchFilter {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tmargin-top: 5.6rem;\n\tmargin-bottom: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tflex-direction: column-reverse;\n\t\tjustify-content: center;\n\t\tgap: 4rem;\n\t}\n}\n\n.tableTitle {\n\tdisplay: grid;\n\t// grid-template-columns: repeat(4, 1fr);\n\twidth: fit-content;\n\tmargin-top: 3rem;\n\tgap: 3rem;\n\tcolor: #9898AB;\n\tborder-bottom: 1px solid #D1D1D1;\n\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tmargin: 5rem 0;\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tgap: 2rem;\n\t\twidth: fit-content;\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: solid 2px var(--color-dark);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.tr2 {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(9, 1fr);\n\tpadding: 1rem 0;\n\n\t>td,\n\tth {\n\t\tdisplay: flex;\n\t\twidth: fit-content;\n\t\tflex-wrap: nowrap;\n\t}\n}\n\n.type {\n\tcontent: '';\n\tbackground-color: var(--color-green);\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tborder-radius: 1.5rem;\n\t// justify-self: center;\n\tmargin-right: 1rem;\n\tdisplay: flex;\n\n\t&__exp {\n\t\tbackground-color: var(--color-error)\n\t}\n\n\t&__inc {\n\t\tbackground-color: var(--color-green);\n\t}\n}\n\n.filterClass {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 5rem;\n\n\t@media only screen and (max-width: $bp-700) {\n\tflex-direction: column-reverse;\n\tgap: 2rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards": `Wallet_cards__sD+63`,
	"cards__ngn": `Wallet_cards__ngn__2n9V9`,
	"cards__usd": `Wallet_cards__usd__Li8Kx`,
	"cards__eur": `Wallet_cards__eur__1zOKA`,
	"cards__gbp": `Wallet_cards__gbp__2pthO`,
	"searchFilter": `Wallet_searchFilter__RF2-L`,
	"tableTitle": `Wallet_tableTitle__2ven2`,
	"main_nav": `Wallet_main_nav__ZZYL6`,
	"main_nav_item": `Wallet_main_nav_item__P8s+v`,
	"main_nav_item_active": `Wallet_main_nav_item_active__ig1V0`,
	"tr2": `Wallet_tr2__w7V5Q`,
	"type": `Wallet_type__fFNTN`,
	"type__exp": `Wallet_type__exp__07Z7q`,
	"type__inc": `Wallet_type__inc__IT6Vc`,
	"filterClass": `Wallet_filterClass__3lhwg`
};
export default ___CSS_LOADER_EXPORT___;
